module.exports = __webpack_public_path__ + "img/mobile/SmartButton-skip/btn-next@2x.png?1.0.17";